import { getAccessToken } from '../authentication/supabaseService';

const API_BASE = '/api/admin';

// ── Types (mirror server/domains/clientAnalytics/clientAnalyticsService.ts) ──

export interface MonthlyBucket {
  month: string; // YYYY-MM
  omzetFood: number;
  omzetDrinks: number;
  omzetTotal: number;
  inslagFood: number;
  inslagDrinks: number;
  inslagNonFood: number;
  inslagTotal: number;
  hasRevenue: boolean;
  hasOrders: boolean;
}

export interface BeforeAfter {
  ccStartDate: string;
  costPctBefore: number | null;
  costPctAfter: number | null;
  deltaPp: number | null;
  trend: string | null;
  monthsBefore: number;
  monthsAfter: number;
}

export interface RestaurantTracker {
  restaurantId: string;
  restaurantName: string;
  months: MonthlyBucket[];
  monthsFilled: number;
  beforeAfter: BeforeAfter | null;
}

export interface ClientTracker {
  clientId: string;
  clientName: string;
  ccStartDate: string | null;
  restaurants: RestaurantTracker[];
}

export interface ClientTrackerResponse {
  from: string;
  to: string;
  months: string[];
  clients: ClientTracker[];
}

async function fetchWithAuth(endpoint: string, options: RequestInit = {}) {
  const token = await getAccessToken();
  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch ${endpoint}: ${response.statusText}`);
  }

  return response.json();
}

export async function getClientTracker(from?: string, to?: string): Promise<ClientTrackerResponse> {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  const qs = params.toString();
  return fetchWithAuth(`/analytics/client-tracker${qs ? `?${qs}` : ''}`);
}

export async function setCcStartDate(userId: string, date: string | null): Promise<void> {
  return fetchWithAuth(`/analytics/cc-start-date/${userId}`, {
    method: 'PUT',
    body: JSON.stringify({ date }),
  });
}
